import { Grid, Typography, Box } from "@material-ui/core";
import React from "react";
import Logo from "../components/Logo";

const AuthTemplate = (props) => {
  return (
    <Grid container item>
      <Grid
        container
        item
        xs={12}
        justifyContent="center"
        style={{ padding: "1rem 1rem 0.5rem" }}
      >
        <Logo width="200px" height="60px" />
      </Grid>
      {props.title !== undefined && (
        <Grid
          container
          item
          xs={12}
          justifyContent="center"
          style={{ padding: "1rem", paddingBottom: "0.25rem" }}
        >
          <Typography variant="h4" align="center" style={{ fontWeight: 600, fontSize: "1.5rem" }}>
            {props.title}
          </Typography>
        </Grid>
      )}
      {props.subtitle !== undefined && (
        <Grid
          container
          item
          xs={12}
          justifyContent="center"
          style={{ padding: "0.5rem 1rem", paddingTop: "0.25rem" }}
        >
          <Typography variant="body2" align="center" color="textSecondary">
            {props.subtitle}
          </Typography>
        </Grid>
      )}
      <Grid item xs={12} style={props.childrenStyle}>
        {props.children}
      </Grid>
    </Grid>
  );
};

export default AuthTemplate;
